import { ThreeDCardPreview } from '@sendoutcards/editor'
import { Button } from '@sendoutcards/quantum-design-ui'
import React from 'react'
import { Dialog } from 'src/design_system/molecules/dialog/Dialog'
import { MinimalCardPreviewFragment } from 'src/graphql/generated/graphql'
import { getIsBackPanelLandscape } from 'src/helpers/getCardBackPanelOrientation'
import {
  mapPanelControlNames,
  mapPanelImages,
} from 'src/helpers/threeDCard/mapPanelImages'
import { useSelector } from 'src/hooks'

export interface PriceProps {
  card?: MinimalCardPreviewFragment
  onClose: () => void
  onSendPhysical?: () => void
  isOpen?: boolean
  title?: string
}

const Simple3DPreviewDialog: React.FC<PriceProps> = props => {
  const { card, onClose, onSendPhysical, isOpen = true, title } = props
  const isMobile = useSelector(state => state.window.width < 500)

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      wrapperStyle={{ overflow: 'hidden' }}
      title={title}
    >
      {card && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <ThreeDCardPreview
            cardType={card.type}
            orientation={card.isHorizontal ? 'LANDSCAPE' : 'PORTRAIT'}
            panels={mapPanelImages(
              card.frontPreviewUrl,
              card.insidePreviewUrl,
              card.backPreviewUrl,
              card.flapPreviewUrl,
              !!card.flapPreviewUrl,
              card.isHorizontal,
            )}
            bgGradientColor={{ shouldDisplayBg: false }}
            height={card.isHorizontal ? '428px' : '600px'}
            maxHeight={onSendPhysical ? '90%' : '100%'}
            minWidth={card.isHorizontal ? '600px' : '428px'}
            maxWidth={'80dvw'}
            control={{
              type: 'Standard',
              panelNames: mapPanelControlNames(card.panels),
              shouldOnlyShowDropdown: isMobile,
            }}
            isBackPanelLandscape={
              card.isHorizontal && getIsBackPanelLandscape(card.panels)
            }
          />
          {onSendPhysical && (
            <div style={{ height: '10%' }}>
              <Button
                title="Send Physical Card"
                type="shadow"
                onClick={onSendPhysical}
              />
            </div>
          )}
        </div>
      )}
    </Dialog>
  )
}

export default Simple3DPreviewDialog
